/* eslint-disable */
/* prettier-ignore */
// Generated by elegant-router
// Read more: https://github.com/soybeanjs/elegant-router

import type { GeneratedRoute } from '@elegant-router/types';

export const generatedRoutes: GeneratedRoute[] = [
  {
    name: '403',
    path: '/403',
    component: 'layout.blank$view.403',
    meta: {
      constant: true,
      title: '403',
      i18nKey: 'route.403',
      hideInMenu: true
    }
  },
  {
    name: '404',
    path: '/404',
    component: 'layout.blank$view.404',
    meta: {
      title: '404',
      i18nKey: 'route.404',
      constant: true,
      hideInMenu: true
    }
  },
  {
    name: '500',
    path: '/500',
    component: 'layout.blank$view.500',
    meta: {
      title: '500',
      i18nKey: 'route.500',
      constant: true,
      hideInMenu: true
    }
  },
  {
    name: 'affiliate',
    path: '/affiliate',
    component: 'layout.base$view.affiliate',
    meta: {
      constant: true,
      title: 'affiliate',
      icon: 'hugeicons:computer-dollar',
      i18nKey: 'route.affiliate',
      order: 20,
      footer: true
    }
  },
  {
    name: 'api-keys',
    path: '/api-keys',
    component: 'layout.base$view.api-keys',
    meta: {
      title: 'api-keys',
      icon: 'icon-park-outline:api',
      i18nKey: 'route.api-keys',
      order: 6
    }
  },
  {
    name: 'billing',
    path: '/billing',
    component: 'layout.base',
    meta: {
      title: 'billing',
      icon: 'icon-park-outline:computer-one',
      i18nKey: 'route.billing',
      order: 3
    },
    children: [
      {
        name: 'billing_credit',
        path: '/billing/credit',
        component: 'view.billing_credit',
        meta: {
          title: 'billing_credit',
          icon: 'icon-park-outline:credit',
          i18nKey: 'route.billing_credit',
          order: 1
        }
      },
      {
        name: 'billing_history',
        path: '/billing/history',
        component: 'view.billing_history',
        meta: {
          title: 'billing_history',
          icon: 'icon-park-outline:history-query',
          i18nKey: 'route.billing_history',
          order: 3
        }
      },
      {
        name: 'billing_packages',
        path: '/billing/packages',
        component: 'view.billing_packages',
        meta: {
          title: 'billing_packages',
          icon: 'icon-park-outline:creative',
          i18nKey: 'route.billing_packages',
          order: 2
        }
      }
    ]
  },
  {
    name: 'home',
    path: '/home',
    component: 'layout.base$view.home',
    meta: {
      constant: true,
      title: 'home',
      icon: 'icon-park-outline:data-screen',
      i18nKey: 'route.home',
      order: 1,
      guestViewable: true,
      authRequiredActions: ['create-api-key', 'modify-settings']
    }
  },
  {
    name: 'limits',
    path: '/limits',
    component: 'layout.base$view.limits',
    meta: {
      constant: true,
      title: 'limits',
      icon: 'icon-park-outline:permissions',
      i18nKey: 'route.limits',
      order: 7
    }
  },
  {
    name: 'login',
    path: '/login/:module(pwd-login|code-login|register|reset-pwd|bind-wechat)?',
    component: 'layout.blank$view.login',
    props: true,
    meta: {
      title: 'login',
      i18nKey: 'route.login',
      constant: true,
      hideInMenu: true
    }
  },
  {
    name: 'models',
    path: '/models',
    component: 'layout.base$view.models',
    meta: {
      constant: true,
      title: 'models',
      icon: 'icon-park-outline:all-application',
      i18nKey: 'route.models',
      order: 2
    }
  },
  {
    name: 'usage',
    path: '/usage',
    component: 'layout.base',
    meta: {
      title: 'usage',
      icon: 'icon-park-outline:chart-histogram-two',
      i18nKey: 'route.usage',
      order: 5
    },
    children: [
      {
        name: 'usage_overview',
        path: '/usage/overview',
        component: 'view.usage_overview',
        meta: {
          title: 'usage_overview',
          icon: 'icon-park-outline:chart-histogram-one',
          i18nKey: 'route.usage_overview',
          order: 1
        }
      },
      {
        name: 'usage_reports',
        path: '/usage/reports',
        component: 'view.usage_reports',
        meta: {
          title: 'usage_reports',
          icon: 'icon-park-outline:table-report',
          i18nKey: 'route.usage_reports',
          order: 4
        }
      }
    ]
  }
];
